// Generated by Melange

import * as Buhta_cabinet__AuthConfirm from "./AuthConfirm.js";
import * as Buhta_cabinet__AuthErrorForm from "./AuthErrorForm.js";
import * as Buhta_cabinet__AuthTemplate from "../../templates/AuthTemplate.js";
import * as Buhta_cabinet__ClientConsentForm from "./ClientConsentForm.js";
import * as Buhta_cabinet__ClientLogoutForm from "./ClientLogoutForm.js";
import * as Buhta_cabinet__LoginForm from "./LoginForm.js";
import * as Buhta_cabinet__LogoutForm from "./LogoutForm.js";
import * as Buhta_cabinet__RecoveryForm from "./RecoveryForm.js";
import * as Buhta_cabinet__RegisterIdentityForm from "./RegisterIdentityForm.js";
import * as Buhta_cabinet__ResetPasswordForm from "./ResetPasswordForm.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(tab) {
  return function (payload) {
    let tmp;
    if (typeof tab === "number") {
      switch (tab) {
        case /* Login */0 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__LoginForm.make, {
                  payload: payload
                });
            break;
        case /* Logout */1 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__LogoutForm.make, {
                  payload: payload
                });
            break;
        case /* Recovery */2 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__RecoveryForm.make, {
                  payload: payload
                });
            break;
        case /* Confirm */3 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__AuthConfirm.make, {});
            break;
        case /* ResetPassword */4 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__ResetPasswordForm.make, {
                  payload: payload
                });
            break;
        case /* ClientConsent */5 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__ClientConsentForm.make, {
                  payload: payload
                });
            break;
        case /* ClientLogout */6 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__ClientLogoutForm.make, {
                  payload: payload
                });
            break;
        case /* RegisterIdentity */7 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__RegisterIdentityForm.make, {
                  payload: payload
                });
            break;
        case /* Error */8 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__AuthErrorForm.make, {
                  payload: payload
                });
            break;
        
      }
    } else {
      tmp = "obsolete register route";
    }
    return JsxRuntime.jsx(Buhta_cabinet__AuthTemplate.make, {
                children: tmp
              });
  };
}

function AuthPage(Props) {
  return make(Props.tab)(Props.payload);
}

const make$1 = AuthPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__AuthConfirm Not a pure module */
